import { Injectable, inject, signal, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { STORAGE_KEY } from '../../data';

export type Language = 'es' | 'en';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private availableLanguages: Language[] = ['es', 'en'];
    private readonly injector = inject(Injector);

    private get translate(): TranslateService {
        return this.injector.get(TranslateService);
    }

    readonly current = signal<Language>(this.getInitialLanguage());
    readonly defaultLang = signal<Language>('es');

    private getInitialLanguage(): Language {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'en' || saved === 'es') return saved;
        const browserLang = navigator.language?.split('-')[0];
        if (browserLang === 'en' || browserLang === 'es') return browserLang;
        return 'es';
    }

    toggle(): void {
        const next: Language = this.current() === 'es' ? 'en' : 'es';
        this.changeLanguage(next);
    }

    changeLanguage(language: Language): void {
        if (this.availableLanguages.includes(language)) {
            this.translate.use(language);
            this.current.set(language);
            localStorage.setItem(STORAGE_KEY, language);
        }
    }

    getCurrentLanguage(): Language {
        return this.current();
    }

    getAvailableLanguages(): Language[] {
        return this.availableLanguages;
    }

    instant(key: string, params?: Record<string, unknown>): string {
        return this.translate.instant(key, params);
    }
}
